import { AttributeGroup } from "./attribute-group";
import { Brand } from "./brand";
import { Category } from "./category";
import { Country } from "./country";
import { PricingStats } from "./pricing-stats";
import { Retailer } from "./retailer";
import { Supplier } from "./supplier";
import { UnitMeasure } from "./unit-measure";

export class Sku {
    constructor(
        public id: number,
        public emiItemId: number,
        public globalItemId: number,
        public name: string,
        public englishName: string,
        public description: string,
        public ingredients: string,
        public country: Country,
        public category: Category,
        public emiImageUrl: string,
        public industryCode: string,
        public brand: Brand,
        public pricingStats: PricingStats,
        public retailer: Retailer,
        public supplier: Supplier,
        public attributeGroups: AttributeGroup[],
        public measures: UnitMeasure[],
        public totalSkuSize: number
    ) { }
}
